import { MatrixFormatError } from '@/models/matrix-format-error';

function matrixFormatErrorKeyBuilder(error: MatrixFormatError): string {
  return [
    error.purchaseCondition.rowIndex,
    error.purchaseCondition.ean,
    error.purchaseCondition.ref,
    error.purchaseCondition.circuit,
    error.field,
    error.message
  ].join('-');
}

function addKeyToMatrixFormatError(error: MatrixFormatError): MatrixFormatError & { key: string } {
  const key = matrixFormatErrorKeyBuilder(error);
  return { key, ...error };
}

export function addKeyToMatrixFormatErrors(items: MatrixFormatError[]): (MatrixFormatError & { key: string })[] {
  return items.map(addKeyToMatrixFormatError);
}
